import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Associate a user with Trimble Maps products/roles
 * @param accountId Id of the account
 * @param userId Id of the user
 * @param request.email user's email
 * @param request.firstname user's first name
 * @param request.lastName user's last name
 * @param request.password user password (Optional)
 * @param request.productRoles array of products and their corresponding roles
 */
export function putProductsAccountsUsersV2(
  this: unknown,
  accountId: number,
  userId: number,
  request: {
    email: string;
    firstName: string;
    lastName: string;
    password?: string;
    productRoles: {
      applicationName: null | string;
      roles: { name: string }[];
    }[];
  }
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsV2Url
      }/accounts/${encodeURIComponent(accountId)}/users/${encodeURIComponent(
        userId
      )}`,
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(request),
      }
    )
  ).pipe(
    selectData(
      z.object({
        data: z.string(),
        errorList: z.array(
          z.object({
            code: z.string(),
            description: z.string(),
          })
        ),
        status: z.union([z.literal('Successful'), z.literal('Failed')]),
      })
    )
  );
}
